import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import ChannelEventFlow from './components/ChannelEventFlow';
import PublicEventView from './pages/PublicEventView';

function PublicPageWrapper() {
  const { channelId, groupId } = useParams();
  return <PublicEventView channelId={channelId} groupId={groupId} />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ChannelEventFlow />} />
        <Route path="/public/:channelId/:groupId" element={<PublicPageWrapper />} />
        <Route path="/public/:channelId" element={<PublicPageWrapper />} />
      </Routes>
    </Router>
  );
}
